export default "__VITE_ASSET__DMMQMtN9__"